/* Fathead RUM v2. web-vitals 6.2.1 owns metric lifecycle and bfcache handling. */
(function () {
  'use strict';
  if (window.__fhVitalsStarted || !window.webVitals) return;
  window.__fhVitalsStarted = true;
  var template = window._template && window._template.name || 'unknown';
  var preview = !!(window.Shopify && window.Shopify.theme && window.Shopify.theme.role !== 'main');
  var metrics = {};
  var pending = new Map();
  var sent = new Map();
  // In-memory diagnostics only: no customer IDs, query terms, URLs, or storage.
  window.fhWebVitals = { version: '6.2.1', release: 'cro-wave0', template: template, preview: preview, metrics: metrics };

  function allowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    return !preview && privacy && typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed() === true;
  }
  function flush() {
    if (!allowed()) return;
    pending.forEach(function (payload, key) {
      if (sent.get(key) === payload.metric_value) {
        pending.delete(key);
        return;
      }
      try {
        // Pending callbacks may have been coalesced. Delta describes the
        // samples handed to gtag, not an intermediate unsent callback.
        payload.metric_delta = payload.metric_value - (sent.get(key) || 0);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: 'web_vital' }, payload));
        sent.set(key, payload.metric_value);
        pending.delete(key);
      } catch (_) { /* A later consent/visibility event may retry. */ }
    });
  }
  function report(metric) {
    if (!Number.isFinite(metric.value) || metric.value < 0) return;
    metrics[metric.name] = { value: metric.value, rating: metric.rating, id: metric.id };
    // The library may finalize a metric again after another interaction/hidden
    // cycle. INP can return to an earlier value as its percentile changes.
    // Keep only the latest unsent sample and compare it with the most recently
    // sent value, never every value previously seen for this metric ID.
    var key = metric.id;
    pending.set(key, {
      metric_name: metric.name,
      metric_id: metric.id,
      metric_value: metric.value,
      metric_delta: metric.delta,
      metric_rating: metric.rating,
      navigation_type: metric.navigationType,
      page_type: template,
      release: 'cro-wave0',
      non_interaction: true,
      transport_type: 'beacon'
    });
    flush();
  }
  ['onCLS', 'onINP', 'onLCP', 'onFCP', 'onTTFB'].forEach(function (name) {
    if (typeof window.webVitals[name] === 'function') window.webVitals[name](report);
  });
  document.addEventListener('visitorConsentCollected', function () {
    if (!allowed()) pending.clear();
    else flush();
  });
  document.addEventListener('visibilitychange', flush);
  window.addEventListener('pagehide', flush);
})();
